export const TRANSLATION_KEY = 'dashboard';

export const PATHS = {
  DASHBOARD: '/dashboard',
};
